import {updateBusinessPortalStatsDoc} from "@/shared/firebase_utils";

const state = {
    businessPortalStats: {}
};

const getters = {
    businessPortalStats: (state) => state.businessPortalStats,
};

const actions = {
    async onBusinessPortalStatsSnapshot({ commit }, documentData) {
            commit('setBusinessPortalStats', documentData);
    },
    async clearBusinessPortalStats({ commit }) {
        commit('clearBusinessPortalStats');
    },
    async resetIsNewNotifications({ rootState }) {
        if(state.businessPortalStats.isNewNotifications != false) {
            await updateBusinessPortalStatsDoc(rootState.userProfile.userProfile.businessProfileId, { isNewNotifications: false })
        }
    },
};

const mutations = {
    clearBusinessPortalStats: (state) => {
        state.businessPortalStats = [];
    },
    setBusinessPortalStats: (state, businessPortalStats) => {
        state.businessPortalStats = businessPortalStats;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}